import Sandbox from '@/components/Sandbox';

const GlugDemo = () => {
  return (
    <Sandbox
      title="Rising Pitch Demo"
      layout="split"
      size="wide"
      splitRatio={0.65}
      minPreviewHeight="12rem"
      dependencies={{
        'use-sound': '4.0.3',
      }}
      files={{
        '/App.js': `
import React from 'react';
import useSound from 'use-sound';

import styles from './RisingDemo.module.css';

function RisingDemo() {
  const soundUrl = '/sounds/glug-a.mp3';

  const [playbackRate, setPlaybackRate] = React.useState(0.75);

  const [play] = useSound(soundUrl, {
    playbackRate,
    volume: 0.5,
  });

  const handleClick = () => {
    setPlaybackRate(playbackRate + 0.1);
    play();
  };

  return (
    <button className={styles.btn} onClick={handleClick}>
      <span role="img" aria-label="Like this post">
        💖
      </span>
    </button>
  );
}

export default RisingDemo;
        `,
        '/RisingDemo.module.css': {
          hidden: true,
          code: `
.btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  padding: 16px;
  border: none;
  border-radius: 1000px;
  background: transparent;
  font-size: 4rem;
  font-weight: var(--font-weight-bold);
  filter:
    drop-shadow(1px 2px 2px hsl(0deg 0% 0% / 0.25))
    drop-shadow(3px 6px 6px hsl(0deg 0% 0% / 0.175));
}
.btn span {
  transform-origin: center center;
}
.btn:active span {
  transform: scale(1.1);
}`,
        },
      }}
    />
  );
};

export default GlugDemo;
